import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { Formik, Form } from 'formik';
import { Box } from '@mui/material';
import ActivityIndicator from '../ActivityIndicator';
import FilterDialog from '../Feedback/FilterDialog';
import { filterFormSx } from './Filters.styles';
import { FilterDialogContext } from './FilterDialogContext';

const Filters = forwardRef((props, formRef) => {
  const { status, open, children, initialValues, onClose, onApply, onReset } =
    props;

  const handleFiltersApply = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  const handleClose = () => {
    if (formRef.current) {
      formRef.current.resetForm({ values: initialValues });
    }
    onClose();
  };

  const renderForm = () => {
    return (
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={onApply}
        enableReinitialize
      >
        {(form) => {
          return (
            <FilterDialogContext.Provider value>
              <Box component={Form} sx={filterFormSx} noValidate>
                {typeof children === 'function' ? children(form) : children}
              </Box>
            </FilterDialogContext.Provider>
          );
        }}
      </Formik>
    );
  };

  const renderFetchState = () => {
    switch (status) {
      case 'loading':
        return <ActivityIndicator />;
      case 'success':
        return renderForm();
      default:
        return null;
    }
  };

  return (
    <FilterDialog
      open={open}
      onClose={handleClose}
      onApply={handleFiltersApply}
      onResetAll={onReset}
    >
      {status === undefined ? renderForm() : renderFetchState()}
    </FilterDialog>
  );
});

Filters.propTypes = {
  open: Type.bool.isRequired,
  onClose: Type.func.isRequired,
  onApply: Type.func.isRequired,
  onReset: Type.func.isRequired,
  status: Type.oneOf(['idle', 'loading', 'error', 'success']),
  initialValues: Type.object.isRequired, // eslint-disable-line react/forbid-prop-types,
  children: Type.oneOfType([Type.node, Type.func]).isRequired,
};

Filters.defaultProps = {
  status: undefined,
};

export default Filters;
